import {Component, OnInit} from '@angular/core';
import {HaushaltForm} from "./haushalt.form";
import {EingabeStepComponent} from "../eingabe/eingabe.step.component";

/**
 * Overwrite the Generic step component for the first section fo the stancheck.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-haushalt',
    templateUrl: '../../step/step.component.html',
    standalone: false
})
export class HaushaltStepComponent extends EingabeStepComponent implements OnInit {

  hideHelpForSteps = [
    'waschen-und-spuelen/1',
    'waschen-und-spuelen/2',
    'waschen-und-spuelen/3',
    'waschen-und-spuelen/5',
    'kuehlen-und-gefrieren/1',
    'kuehlen-und-gefrieren/2',
    'kochen-und-backen/1',
    'kochen-und-backen/3',
    'kochen-und-backen/4',
    'kochen-und-backen/5',
    'kochen-und-backen/7',
    'kochen-und-backen/9',
    'kochen-und-backen/10',
    'unterhaltungselektronik/1',
    'unterhaltungselektronik/2',
    'unterhaltungselektronik/4',
    'unterhaltungselektronik/5',
    'unterhaltungselektronik/6',
  ];
  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in these steps and init the parent form
    this.formConfig = new HaushaltForm();
    super.ngOnInit();
  }
}
